export default {
  0: {
    codes: [
      'MediaPlayPause',
    ],
    keys: [
      'MediaPlayPause',
    ],
  },
  8: {
    codes: [
      'Backspace',
    ],
    keys: [
      '`',
      'Backspace',
    ],
  },
  9: {
    codes: [
      'Tab',
    ],
    keys: [
      'Tab',
    ],
  },
  13: {
    codes: [
      'Enter',
    ],
    keys: [
      'Enter',
    ],
  },
  16: {
    codes: [
      'ShiftLeft',
      'ShiftRight',
    ],
    keys: [
      'Shift',
    ],
  },
  17: {
    codes: [
      'ControlLeft',
      'ControlRight',
    ],
    keys: [
      'Control',
    ],
  },
  18: {
    codes: [
      'AltLeft',
      'AltRight',
    ],
    keys: [
      'Alt',
      'AltGraph',
      'AltRight',
    ],
    altKeys: [
      'AltLeft',
    ],
  },
  20: {
    codes: [
      'CapsLock',
    ],
    keys: [
      'CapsLock',
    ],
  },
  27: {
    codes: [
      'Escape',
    ],
    keys: [
      'Escape',
    ],
  },
  33: {
    codes: [
      'PageUp',
    ],
    keys: [
      'PageUp',
    ],
  },
  34: {
    codes: [
      'PageDown',
    ],
    keys: [
      'PageDown',
    ],
  },
  35: {
    codes: [
      'End',
    ],
    keys: [
      'End',
    ],
  },
  36: {
    codes: [
      'Home',
    ],
    keys: [
      'Home',
    ],
  },
  37: {
    codes: [
      'ArrowLeft',
    ],
    keys: [
      'ArrowLeft',
    ],
  },
  38: {
    codes: [
      'ArrowUp',
    ],
    keys: [
      'ArrowUp',
    ],
  },
  39: {
    codes: [
      'ArrowRight',
    ],
    keys: [
      'ArrowRight',
    ],
  },
  40: {
    codes: [
      'ArrowDown',
    ],
    keys: [
      'ArrowDown',
    ],
  },
  45: {
    codes: [
      'Insert',
    ],
    keys: [
      'Insert',
    ],
  },
  46: {
    codes: [
      'Delete',
    ],
    keys: [
      'Delete',
    ],
  },
  48: {
    codes: [
      'Digit0',
    ],
    keys: [
      'Digit0',
      '=',
    ],
  },
  49: {
    codes: [
      'Digit1',
    ],
    keys: [
      'Digit1',
      '1',
      '!',
    ],
  },
  50: {
    codes: [
      'Digit2',
    ],
    keys: [
      'Digit2',
      '2',
      '"',
    ],
  },
  51: {
    codes: [
      'Digit3',
    ],
    keys: [
      'Digit3',
      '3',
      '§',
    ],
  },
  52: {
    codes: [
      'Digit4',
    ],
    keys: [
      'Digit4',
      '4',
      '$',
    ],
  },
  53: {
    codes: [
      'Digit5',
    ],
    keys: [
      'Digit5',
      '5',
      '%',
    ],
  },
  54: {
    codes: [
      'Digit6',
    ],
    keys: [
      'Digit6',
      '6',
      '&',
    ],
  },
  55: {
    codes: [
      'Digit7',
    ],
    keys: [
      'Digit7',
      '7',
      '/',
    ],
  },
  56: {
    codes: [
      'Digit8',
    ],
    keys: [
      'Digit8',
      '8',
      '(',
    ],
  },
  57: {
    codes: [
      'Digit9',
    ],
    keys: [
      'Digit9',
      '9',
      ')',
    ],
  },
  59: {
    codes: [
      'BracketLeft',
    ],
    keys: [
      'BracketLeft',
      'Ü',
      'ü',
    ],
  },
  60: {
    codes: [
      'IntlBackslash',
    ],
    keys: [
      '>',
      '<',
      'IntlBackslash',
    ],
  },
  63: {
    codes: [
      'Minus',
    ],
    keys: [
      'Minus',
      '?',
      '`?',
    ],
  },
  65: {
    codes: [
      'KeyA',
    ],
    keys: [
      'KeyA',
      'a',
      'A',
    ],
  },
  66: {
    codes: [
      'KeyB',
    ],
    keys: [
      'KeyB',
      'B',
      'b',
    ],
  },
  67: {
    codes: [
      'KeyC',
    ],
    keys: [
      'KeyC',
      'C',
      'c',
    ],
  },
  68: {
    codes: [
      'KeyD',
    ],
    keys: [
      'KeyD',
      'D',
      'd',
    ],
  },
  69: {
    codes: [
      'KeyE',
    ],
    keys: [
      'KeyE',
      'E',
      'e',
    ],
  },
  70: {
    codes: [
      'KeyF',
    ],
    keys: [
      'KeyF',
      'F',
      'f',
    ],
  },
  71: {
    codes: [
      'KeyG',
    ],
    keys: [
      'KeyG',
      'G',
      'g',
    ],
  },
  72: {
    codes: [
      'KeyH',
    ],
    keys: [
      'KeyH',
      'H',
      'h',
    ],
  },
  73: {
    codes: [
      'KeyI',
    ],
    keys: [
      'KeyI',
      'I',
      'i',
    ],
  },
  74: {
    codes: [
      'KeyJ',
    ],
    keys: [
      'KeyJ',
      'J',
      'j',
    ],
  },
  75: {
    codes: [
      'KeyK',
    ],
    keys: [
      'KeyK',
      'K',
      'k',
    ],
  },
  76: {
    codes: [
      'KeyL',
    ],
    keys: [
      'KeyL',
      'L',
      'l',
    ],
  },
  77: {
    codes: [
      'KeyM',
    ],
    keys: [
      'KeyM',
      'M',
      'm',
    ],
  },
  78: {
    codes: [
      'KeyN',
    ],
    keys: [
      'KeyN',
      'N',
      'n',
    ],
  },
  79: {
    codes: [
      'KeyO',
    ],
    keys: [
      'KeyO',
      'O',
      'o',
    ],
  },
  80: {
    codes: [
      'KeyP',
    ],
    keys: [
      'KeyP',
      'P',
      'p',
    ],
  },
  81: {
    codes: [
      'KeyQ',
    ],
    keys: [
      'KeyQ',
      'Q',
      '@',
      'q',
    ],
  },
  82: {
    codes: [
      'KeyR',
    ],
    keys: [
      'KeyR',
      'R',
      'r',
    ],
  },
  83: {
    codes: [
      'KeyS',
    ],
    keys: [
      'KeyS',
      'S',
      's',
    ],
  },
  84: {
    codes: [
      'KeyT',
    ],
    keys: [
      'KeyT',
      'T',
      't',
    ],
  },
  85: {
    codes: [
      'KeyU',
    ],
    keys: [
      'KeyU',
      'U',
      'u',
    ],
  },
  86: {
    codes: [
      'KeyV',
    ],
    keys: [
      'KeyV',
      'V',
      'v',
    ],
  },
  87: {
    codes: [
      'KeyW',
    ],
    keys: [
      'KeyW',
      'W',
      'w',
    ],
  },
  88: {
    codes: [
      'KeyX',
    ],
    keys: [
      'KeyX',
      'X',
      'x',
    ],
  },
  89: {
    codes: [
      'KeyZ',
    ],
    keys: [
      'Y',
      'KeyZ',
      'y',
    ],
  },
  90: {
    codes: [
      'KeyY',
    ],
    keys: [
      'KeyY',
      'Z',
      'z',
    ],
  },
  91: {
    codes: [
      'OSLeft',
    ],
    keys: [
      'OSLeft',
      'OS',
    ],
  },
  96: {
    codes: [
      'Numpad0',
    ],
    keys: [
      '0',
    ],
  },
  97: {
    codes: [
      'Numpad1',
    ],
    keys: [
      '1',
    ],
  },
  98: {
    codes: [
      'Numpad2',
    ],
    keys: [
      '2',
    ],
  },
  99: {
    codes: [
      'Numpad3',
    ],
    keys: [
      '3',
    ],
  },
  100: {
    codes: [
      'Numpad4',
    ],
    keys: [
      '4',
    ],
  },
  101: {
    codes: [
      'Numpad5',
    ],
    keys: [
      '5',
    ],
  },
  102: {
    codes: [
      'Numpad6',
    ],
    keys: [
      '6',
    ],
  },
  103: {
    codes: [
      'Numpad7',
    ],
    keys: [
      '7',
    ],
  },
  104: {
    codes: [
      'Numpad8',
    ],
    keys: [
      '8',
    ],
  },
  105: {
    codes: [
      'Numpad9',
    ],
    keys: [
      '9',
    ],
  },
  110: {
    codes: [
      'NumpadDecimal',
    ],
    keys: [
      ',',
    ],
  },
  112: {
    codes: [
      'F1',
    ],
    keys: [
      'F1',
    ],
  },
  113: {
    codes: [
      'F2',
    ],
    keys: [
      'F2',
    ],
  },
  114: {
    codes: [
      'F3',
    ],
    keys: [
      'F3',
    ],
  },
  117: {
    codes: [
      'F6',
    ],
    keys: [
      'F6',
    ],
  },
  119: {
    codes: [
      'F8',
    ],
    keys: [
      'F8',
    ],
  },
  120: {
    codes: [
      'F9',
    ],
    keys: [
      'F9',
    ],
  },
  121: {
    codes: [
      'F10',
    ],
    keys: [
      'F10',
    ],
  },
  122: {
    codes: [
      'F11',
    ],
    keys: [
      'F11',
    ],
  },
  123: {
    codes: [
      'F12',
    ],
    keys: [
      'F12',
    ],
  },
  160: {
    codes: [
      'Backquote',
    ],
    keys: [
      '°',
      'Dead',
      'Backquote',
      '^^',
    ],
  },
  163: {
    codes: [
      'Backslash',
    ],
    keys: [
      'Backslash',
      '\'',
    ],
  },
  171: {
    codes: [
      'BracketRight',
    ],
    keys: [
      'BracketRight',
      '*',
    ],
  },
  173: {
    codes: [
      'Slash',
    ],
    keys: [
      'Slash',
      '_',
      '-',
    ],
  },
  181: {
    codes: [
      'VolumeMute',
    ],
    keys: [
      'VolumeMute',
    ],
  },
  182: {
    codes: [
      'VolumeDown',
    ],
    keys: [
      'VolumeDown',
    ],
  },
  183: {
    codes: [
      'VolumeUp',
    ],
    keys: [
      'VolumeUp',
    ],
  },
  187: {
    codes: [
      'Equal',
    ],
    keys: [
      'Dead',
    ],
  },
  188: {
    codes: [
      'Comma',
    ],
    keys: [
      'Comma',
      ';',
      ',',
    ],
  },
  190: {
    codes: [
      'Period',
    ],
    keys: [
      'Period',
      ':',
      '.',
    ],
  },
  192: {
    codes: [
      'Equal',
      'Semicolon',
    ],
    keys: [
      'Dead',
      'ö',
      'Semicolon',
      'Ö',
    ],
  },
  222: {
    codes: [
      'Quote',
    ],
    keys: [
      'Quote',
      'Ä',
      'ä',
    ],
  },
  229: {
    codes: [
      'Equal',
    ],
    keys: [
      'Dead',
    ],
  },
};
